import React from "react";
import {
  Form,
  Input,
  Select,
  AutoComplete,
  InputNumber,
  Switch,
  Button,
} from "antd";

const { Option } = Select;
const { TextArea } = Input;

const ConnectionFormElement = (props) => {
  const {
    control,
    errors,
    Controller,
    SFTPConnectionsData,
    setValue,
    isAddMode,
    watch,
    setIsAddMode,
    setConnectionID,
    resetField,
    clearErrors,
  } = props;

  const itemStyles = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
      md: { span: 6 },
      lg: { span: 5 },
      xl: { span: 5 },
      xxl: { span: 5 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
      md: { span: 18 },
      lg: { span: 15 },
      xl: { span: 12 },
      xxl: { span: 12 },
    },
  };

  const connectionTypeChange = (value) => {
    switch (value) {
      case "FTP":
      case "FTPS":
        setValue("connection.port", 21);
        break;
      case "SFTP":
        setValue("connection.port", 22);
        break;
      default:
        setValue("connection.port", 22);
    }
  };

  const onEditConnectionValues = (e, val) => {
    if (e !== undefined && val.key !== undefined) {
      const connectionData = SFTPConnectionsData?.find(
        (el) => el._id === val.key,
      );

      setValue("connection", connectionData);
      setValue(
        "connection.renameConnectionsName",
        connectionData.connectionName,
      );
      setValue("connection.password", null);
      setValue("connection.privateKey", null);
      setValue("connection.privateKeyPassword", null);

      clearErrors();
      setIsAddMode(false);
      setConnectionID(val.key);
    } else {
      resetField("connection.renameConnectionsName");
      resetField("connection.connectionType");
      resetField("connection.host");
      resetField("connection.port");
      resetField("connection.connectTimeout");
      resetField("connection.retryTimes");
      resetField("connection.disconnectTimeout");
      resetField("connection.downloadZeroBytes");
      resetField("connection.forceIPv4");
      resetField("connection.isPassive");
      resetField("connection.authType");
      resetField("connection.username");
      resetField("connection.password");
      resetField("connection.privateKey");
      resetField("connection.privateKeyPassword");
      setIsAddMode(true);
      setConnectionID(undefined);
    }
  };

  const onChangeAuthType = (e) => {
    if (e === "Password") {
      resetField("connection.privateKey");
      resetField("connection.privateKeyPassword");
    } else {
      resetField("connection.password");
    }
  };

  const usenameComponent = (errors) => {
    return (
      <Form.Item
        {...itemStyles}
        label="Username"
        help={errors?.connection?.username?.message}
        required
        validateStatus={errors?.connection?.username ? "error" : ""}
      >
        <Controller
          control={control}
          name="connection.username"
          render={({ field }) => (
            <Input placeholder="Enter Username" {...field} />
          )}
        />
      </Form.Item>
    );
  };

  const authTypeSelector = (isAddMode, errors) => {
    let authTypes = watch("connection.authType");

    switch (authTypes) {
      case "Password":
        return (
          <>
            {usenameComponent(errors)}
            <Form.Item
              {...itemStyles}
              label="Password"
              help={errors?.connection?.password?.message}
              required={isAddMode === true}
              validateStatus={errors?.connection?.password ? "error" : ""}
            >
              <Controller
                control={control}
                name="connection.password"
                render={({ field }) => (
                  <Input.Password placeholder="Enter Password" {...field} />
                )}
              />
            </Form.Item>
          </>
        );
      case "PrivateKey":
        return (
          <>
            {usenameComponent(errors)}
            <Form.Item
              {...itemStyles}
              label="Private key"
              help={errors?.connection?.privateKey?.message}
              required={isAddMode === true}
              validateStatus={errors?.connection?.privateKey ? "error" : ""}
            >
              <Controller
                control={control}
                name="connection.privateKey"
                render={({ field }) => (
                  <TextArea {...field} placeholder="Enter Private key" />
                )}
              />
            </Form.Item>

            <Form.Item
              {...itemStyles}
              label="Private Key Password"
              help={errors?.connection?.privateKeyPassword?.message}
              required={isAddMode === true}
              validateStatus={
                errors?.connection?.privateKeyPassword ? "error" : ""
              }
            >
              <Controller
                control={control}
                name="connection.privateKeyPassword"
                render={({ field }) => (
                  <Input.Password
                    placeholder="Enter Private Key Password"
                    {...field}
                  />
                )}
              />
            </Form.Item>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="container_ab">
        <Form.Item
          {...itemStyles}
          label="Connection Name"
          help={errors?.connection?.connectionName?.message}
          required
          validateStatus={errors?.connection?.connectionName ? "error" : ""}
        >
          <Controller
            control={control}
            name="connection.connectionName"
            render={({ field: { onChange, value } }) => (
              <AutoComplete
                style={{ width: "100%" }}
                showSearch
                allowClear
                filterOption={(input, option) => {
                  return (
                    option.value.toLowerCase().indexOf(input.toLowerCase()) !==
                    -1
                  );
                }}
                onChange={(e, val) => {
                  onChange(e, val);
                  onEditConnectionValues(e, val);
                }}
                value={value}
                placeholder="Enter Connections Name"
              >
                {SFTPConnectionsData !== undefined
                  ? SFTPConnectionsData?.map((elem) => {
                      return (
                        <Option key={elem._id} value={elem.connectionName}>
                          {elem.connectionName}
                        </Option>
                      );
                    })
                  : null}
              </AutoComplete>
            )}
          />
        </Form.Item>

        <div
          className="is_animation_1"
          style={isAddMode ? { maxHeight: "0" } : { maxHeight: "100px" }}
        >
          <Form.Item
            {...itemStyles}
            label="Rename Connections Name"
            help={errors?.connection?.renameConnectionsName?.message}
            required={isAddMode === false}
            validateStatus={
              errors?.connection?.renameConnectionsName ? "error" : ""
            }
          >
            <Controller
              control={control}
              name="connection.renameConnectionsName"
              render={({ field: { onChange, value } }) => (
                <Input
                  onChange={onChange}
                  value={value}
                  placeholder="Rename Connections Name"
                />
              )}
            />
          </Form.Item>
        </div>

        <Form.Item
          {...itemStyles}
          label="Connection Type"
          help={errors?.connection?.connectionType?.message}
          required
          validateStatus={errors?.connection?.connectionType ? "error" : ""}
        >
          <Controller
            control={control}
            name="connection.connectionType"
            render={({ field: { onChange, value } }) => (
              <Select
                style={{ width: "100%" }}
                placeholder="Select Connection Type"
                showSearch
                filterOption={(input, option) => {
                  return (
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) !== -1
                  );
                }}
                onChange={(values) => {
                  onChange(values);
                  connectionTypeChange(values);
                }}
                value={value}
              >
                <Option value="FTP">FTP</Option>
                <Option value="FTPS">FTPS</Option>
                <Option value="SFTP">SFTP</Option>
              </Select>
            )}
          />
        </Form.Item>

        <Form.Item
          {...itemStyles}
          label="Host IP Address"
          help={errors?.connection?.host?.message}
          required
          validateStatus={errors?.connection?.host ? "error" : ""}
        >
          <Controller
            control={control}
            name="connection.host"
            render={({ field }) => (
              <Input placeholder="Enter Host IP Address" {...field} />
            )}
          />
        </Form.Item>
        <Form.Item
          {...itemStyles}
          label="Port"
          help={errors?.connection?.port?.message}
          required
          validateStatus={errors?.connection?.port ? "error" : ""}
        >
          <Controller
            control={control}
            name="connection.port"
            render={({ field }) => (
              <InputNumber {...field} min={0} style={{ width: "100%" }} />
            )}
          />
        </Form.Item>

        <Form.Item
          {...itemStyles}
          label="Retry Times"
          help={errors?.connection?.retryTimes?.message}
          required
          validateStatus={errors?.connection?.retryTimes ? "error" : ""}
        >
          <Controller
            control={control}
            name="connection.retryTimes"
            render={({ field }) => (
              <InputNumber
                {...field}
                placeholder="Enter Connections Retry Times"
                min={0}
                style={{ width: "100%" }}
              />
            )}
          />
        </Form.Item>

        <Form.Item
          {...itemStyles}
          label="Connection Timeout(ms)"
          help={errors?.connection?.connectTimeout?.message}
          required
          validateStatus={errors?.connection?.connectTimeout ? "error" : ""}
        >
          <Controller
            control={control}
            name="connection.connectTimeout"
            render={({ field }) => (
              <InputNumber
                {...field}
                placeholder="Enter Connections Timeout"
                min={0}
                style={{ width: "100%" }}
              />
            )}
          />
        </Form.Item>

        <Form.Item
          {...itemStyles}
          label="Disconnect Timeout(ms)"
          help={errors?.connection?.disconnectTimeout?.message}
          required
          validateStatus={errors?.connection?.disconnectTimeout ? "error" : ""}
        >
          <Controller
            control={control}
            name="connection.disconnectTimeout"
            render={({ field }) => (
              <InputNumber
                {...field}
                placeholder="Enter Disconnect Timeout"
                min={0}
                style={{ width: "100%" }}
              />
            )}
          />
        </Form.Item>

        <Form.Item {...itemStyles} label="Download Zero Bytes">
          <Controller
            control={control}
            name="connection.downloadZeroBytes"
            render={({ field: { onChange, value } }) => (
              <Switch onChange={onChange} checked={value} />
            )}
          />
        </Form.Item>

        <Form.Item {...itemStyles} label="Passive">
          <Controller
            control={control}
            name="connection.isPassive"
            render={({ field: { onChange, value } }) => (
              <Switch onChange={onChange} checked={value} />
            )}
          />
        </Form.Item>

        <Form.Item {...itemStyles} label="Force IPv4">
          <Controller
            control={control}
            name="connection.forceIPv4"
            render={({ field: { onChange, value } }) => (
              <Switch onChange={onChange} checked={value} />
            )}
          />
        </Form.Item>

        <Form.Item
          {...itemStyles}
          label="Authenticate Type"
          help={errors?.connection?.authType?.message}
          required
          validateStatus={errors?.connection?.authType ? "error" : ""}
        >
          <Controller
            control={control}
            name="connection.authType"
            render={({ field: { onChange, value } }) => (
              <Select
                style={{ width: "100%" }}
                showSearch
                placeholder="Select Authenticate Type"
                filterOption={(input, option) => {
                  return (
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) !== -1
                  );
                }}
                onChange={(values) => {
                  onChange(values);
                  onChangeAuthType(values);
                }}
                value={value}
              >
                <Option value="Password">Password</Option>
                <Option value="PrivateKey">Private Key</Option>
              </Select>
            )}
          />
        </Form.Item>

        {authTypeSelector(isAddMode, errors)}
        <Form.Item wrapperCol={{ span: 15, offset: 5 }}>
          <Button type="primary" htmlType="submit">
            {isAddMode ? "Submit " : "Update"}
          </Button>
        </Form.Item>
      </div>
    </>
  );
};

export default ConnectionFormElement;
